import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { CancelContractResponseFail, ContractCancelationReasons } from 'api/eContractingAPI'

type State = {
  errorMessage?: Array<ContractCancelationReasons>
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  errorMessage: undefined,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.ACCEPT_CONTRACT_ASYNC,
    Actions.ACCEPT_CONTRACT_SUCCESS,
    Actions.ACCEPT_CONTRACT_FAIL,
    {},
    CancelContractResponseFail
  >,
): State => {
  switch (action.type) {
    case Actions.ACCEPT_CONTRACT_ASYNC:
    case Actions.ACCEPT_CONTRACT_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.ACCEPT_CONTRACT_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: [
          action.payload?.reason,
          action.payload?.['cancelRequest.contract_id'] && action.payload?.['cancelRequest.contract_id'].length
            ? action.payload?.['cancelRequest.contract_id']
            : undefined,
        ].find((el) => el),
      }
    }
    default:
      return state
  }
}
